/* Limite par personne appliquée au panier, sur toutes les pages.
   La fiche plafonne le sélecteur, mais un client peut ajouter deux fois de suite,
   passer par l'ajout rapide d'une carte produit ou monter la quantité au panier.
   Après chaque changement du panier, on relit /cart.js, on lit le tag
   `limite:<n>` de chaque produit (2 par défaut) et on ramène la ligne à la limite.
   Barrière d'interface : l'enforcement dur demande une fonction de validation. */
(function () {
  var DEFAUT = 2;
  var cacheLimites = {};
  var enCours = false;

  function limiteDe(handle) {
    if (cacheLimites[handle]) return Promise.resolve(cacheLimites[handle]);
    return fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : { tags: [] }; })
      .then(function (p) {
        var lim = DEFAUT;
        (p.tags || []).forEach(function (t) {
          if (t.indexOf('limite:') === 0) {
            var n = parseInt(t.split(':')[1], 10);
            if (n > 0) lim = n;
          }
        });
        cacheLimites[handle] = lim;
        return lim;
      })
      .catch(function () { return DEFAUT; });
  }

  function message(texte) {
    var old = document.querySelector('.gu-toast-limite');
    if (old) old.remove();
    var d = document.createElement('div');
    d.className = 'gu-toast-limite';
    d.setAttribute('role', 'status');
    d.textContent = texte;
    d.style.cssText = 'position:fixed;left:16px;right:16px;bottom:24px;z-index:2147483000;' +
      'background:#1a1330;color:#fff;border-radius:12px;padding:14px 16px;' +
      'font:600 14px/1.4 Inter,system-ui,sans-serif;box-shadow:0 10px 30px rgba(0,0,0,.25);' +
      'max-width:480px;margin:0 auto;text-align:center';
    document.body.appendChild(d);
    setTimeout(function () { d.remove(); }, 5000);
  }

  function verifier() {
    if (enCours) return Promise.resolve();
    enCours = true;
    return window.__guFetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // quantité totale par produit (toutes variantes confondues)
        var parProduit = {};
        cart.items.forEach(function (it) {
          var p = parProduit[it.handle] || (parProduit[it.handle] = { total: 0, lignes: [] });
          p.total += it.quantity;
          p.lignes.push(it);
        });
        var handles = Object.keys(parProduit);
        return Promise.all(handles.map(limiteDe)).then(function (lims) {
          var corrections = [];
          handles.forEach(function (h, i) {
            var lim = lims[i], p = parProduit[h], exces = p.total - lim;
            if (exces <= 0) return;
            for (var j = p.lignes.length - 1; j >= 0 && exces > 0; j--) {
              var l = p.lignes[j], retire = Math.min(exces, l.quantity);
              corrections.push({ key: l.key, quantity: l.quantity - retire, titre: l.product_title, lim: lim });
              exces -= retire;
            }
          });
          if (!corrections.length) return;
          return corrections.reduce(function (acc, c) {
            return acc.then(function () {
              return window.__guFetch('/cart/change.js', {
                method: 'POST', credentials: 'same-origin',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: c.key, quantity: c.quantity })
              });
            });
          }, Promise.resolve()).then(function () {
            var c = corrections[0];
            try { sessionStorage.setItem('gu-limite-msg', c.titre + ': massimo ' + c.lim + ' a persona. Abbiamo aggiornato il tuo carrello.'); } catch (e) {}
            location.reload();
          });
        });
      })
      .catch(function () {})
      .then(function () { enCours = false; });
  }

  // On observe les appels qui modifient le panier (ajout, ajout rapide, changement de quantité).
  if (!window.__guFetch) {
    window.__guFetch = window.fetch.bind(window);
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = window.__guFetch(input, init);
      if (/\/cart\/(add|change|update)(\.js)?/.test(url)) {
        p.then(function () { setTimeout(verifier, 50); });
      }
      return p;
    };
  }

  try {
    var m = sessionStorage.getItem('gu-limite-msg');
    if (m) { sessionStorage.removeItem('gu-limite-msg'); document.addEventListener('DOMContentLoaded', function () { message(m); }); if (document.readyState !== 'loading') message(m); }
  } catch (e) {}

  verifier();
})();
